<div class="flex items-center justify-between gap-[0.5rem] bg-(--p-white) rounded-[0.5rem] border border-transparent"
  [ngClass]="{ '!border-(--p-primary-50) p-[0.75rem]': showBorder() }">
  <span class="text-[0.75rem] font-[500] text-(--p-blue-500) leading-[150%]" translate="@@edit-comment-no-comments-yet"></span>

  <p-button *ngxPermissionsOnly="addPermissions()"
    [text]="true"
    severity="contrast"
    styleClass="!h-7
      !px-1.5
      !py-1
      !gap-0
      !text-(--p-primary-500)
      hover:!bg-(--p-neutral-500)
      hover:!border-(--p-primary-100)"
    (click)="add.emit()">
    <span class="text-(--p-blue-500) text-[0.75rem] font-[500] leading-[150%]" translate="@@edit-comment-add"></span>
  </p-button>
</div>
